(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('gaia-header');
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

    // Calculate --header-total-height (all sections above header, plus --header-height)
    let totalHeight = 0;
    let headerSection = header.closest('.shopify-section');
    let prev = headerSection && headerSection.previousElementSibling;
    while (prev) {
      if (prev.classList.contains('shopify-section')) {
        totalHeight += prev.getBoundingClientRect().height;
      }
      prev = prev.previousElementSibling;
    }

    const headerHeight = header.offsetHeight;
    totalHeight += headerHeight;
    document.documentElement.style.setProperty('--header-total-height', `${parseInt(totalHeight)}px`);

    var headerObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

        // Recalculate total height on header resize
        let totalHeight = 0;
        let headerSection = header.closest('.shopify-section');
        let prev = headerSection && headerSection.previousElementSibling;
        while (prev) {
          if (prev.classList.contains('shopify-section')) {
            totalHeight += prev.getBoundingClientRect().height;
          }
          prev = prev.previousElementSibling;
        }

        const headerHeight = header.offsetHeight;
        totalHeight += headerHeight;
        document.documentElement.style.setProperty('--header-total-height', `${parseInt(totalHeight)}px`);
      }
    });

    // Observe one or multiple elements
    headerObserver.observe(header);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow-image-with-text"] && !Shopify.designMode) return;
  try {
    
  // <script src="https://cdn.shopify.com/s/files/1/0625/9313/8947/files/swiper-bundle.min.js?v=1690967110" defer="defer"></script>

  } catch(e) { console.error(e); }
})();
})();
